import client from "./client";

export const globalSearch = (query) => client.get(`/search?q=${encodeURIComponent(query)}`);
